var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c("img", {
        staticStyle: { width: "18px", height: "18px", cursor: "pointer" },
        attrs: { src: _vm.jianIcon, alt: "" },
        on: {
          mouseenter: _vm.jianEnter,
          mouseleave: _vm.jianLeave,
          click: _vm.jianFn,
        },
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.count,
            expression: "count",
          },
        ],
        staticClass: "ipt",
        attrs: {
          type: "text",
          onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
        },
        domProps: { value: _vm.count },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.count = $event.target.value
            },
            _vm.getCount,
          ],
        },
      }),
      _c("img", {
        staticStyle: { width: "18px", height: "18px", cursor: "pointer" },
        attrs: { src: _vm.jiaIcon, alt: "" },
        on: {
          mouseenter: _vm.jiaEnter,
          mouseleave: _vm.jiaLeave,
          click: _vm.jiaFn,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }